import React, { useState } from 'react';
import createClient from '../Client';
import emailjs from 'emailjs-com';

// contact component 
const Contact = () => {
    const [formData, setFormData] = useState({
        form_data_title: '',
        form_data_email: '',
        form_data_phone: '',
        form_data_subject: '',
        form_data_message: '',
        form_data_demo_request: false,
    });
    const [responseMessage, setResponseMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /^(?!.*\.{2})[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?!.*\.$)/;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleCheckboxChange = (e) => {
        setFormData({
            ...formData,
            form_data_demo_request: e.target.checked,
        });
    };
    const validate = () => {
        if (!formData.form_data_title) {
            return 'Please enter your name';
        }
        if (formData.form_data_phone && !phoneRegex.test(formData.form_data_phone)) {
            return 'Please enter a valid phone number (10 digits)';
        }
        if (!formData.form_data_email) {
            return 'Please enter your email';
        }
        if (!emailRegex.test(formData.form_data_email)) {
            return 'Please enter a valid email address';
        }
        if (!formData.form_data_message) {
            return 'Please enter your message';
        }
        return null;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const error = validate();
        if (error) {
            setError(error);
            return;
        }
        // const finalFormData = { ...formData };
        if (!formData.form_data_subject) {
            formData.form_data_subject = 'OrthoPed Contact Form';
        }

        // Send form data to EmailJS
        // emailjs.sendForm('service_7kh6qyt', 'template_dwr2drk', event.target, 'OAFjLULXj2KPis4hG')
        // .then((result) => {
        // console.log('Email sent:', result.text);
        // }, (error) => {
        // console.log('Error:', error.text);
        // });
        emailjs.sendForm('service_4etqzh3', 'template_8jqg3up', event.target, 'ZgpEwS9seqTduqsAf')
        .then((result) => {
        console.log('Email sent:', result.text);
        }, (error) => {
        console.log('Error:', error.text);
        });


        try {
            // Send data to Sanity
            createClient.create({
                _type: "form",
                ...formData
            });

            //to delete the bulk data in backend
            // async function deleteBulkData() {
            //     const query = '*[_type == "form"]';
            //     const docs = await createClient.fetch(query);
               
            //     console.log(docs);
            //     const mutations = docs.map((doc) => ({
            //       delete: { id: doc._id },
            //     }));
               
            //     await createClient.mutate(mutations);
            //     console.log('Documents deleted successfully');
            //   }
            //   deleteBulkData();

            console.log("Data sent to Sanity successfully");

            //reset form fields or show success message
            setFormData({
                form_data_title: "",
                form_data_email: "",
                form_data_phone: "",
                form_data_subject: "",
                form_data_message: "",
                form_data_demo_request: false,
            });
        } catch (error) {
            console.error("Error sending data to Sanity:", error.message);
        }

        setSuccess('Form submitted successfully!');
        setError(null);
    };



    return (

        <section className="blog p-top-70">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 ">
                        <form onSubmit={handleSubmit}>
                            <input className="form-control" type="text" placeholder="Name *"
                                name="form_data_title" value={formData.form_data_title} onChange={handleChange} />
                            <input className="form-control" type="text" placeholder="E-mail *"
                                name="form_data_email" value={formData.form_data_email} onChange={handleChange} />
                            <input className="form-control" type="text" placeholder="Phone"
                                name="form_data_phone" value={formData.form_data_phone} onChange={handleChange} />
                            <input className="form-control" type="text" placeholder="Subject"
                                name="form_data_subject" value={formData.form_data_subject} onChange={handleChange} />
                            <input className="form-control" type="textarea" placeholder="Type your message *"
                                 name="form_data_message" value={formData.form_data_message} onChange={handleChange} />
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="demoRequest"
                                    name="form_data_demo_request"
                                    checked={formData.form_data_demo_request}
                                    onChange={handleCheckboxChange}
                                />
                                <label className="form-check-label" htmlFor="demoRequest">
                                    I'm interested in a demo
                                </label>
                            </div>
                            <button type="submit" className='send' disabled={loading}>
                                {loading ? 'Sending...' : 'Send'}
                            </button>
                            {responseMessage && <p>{responseMessage}</p>}
                        </form>
                        {error && <p className="contact-error">{error}</p>}
                        {success && <p className="contact-sucess" >{success}</p>}
                    </div>
                </div>
            </div>
        </section>

    );
}

export default Contact;